export default __webpack_public_path__ + "agent_bg36ee741.png";